import styled, { keyframes } from 'styled-components';

const scrollBrands = keyframes`
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
`;

export const Section = styled.section`
  width: 100%;
  padding: 6rem 0;
  overflow: hidden;
  background: var(--white, #ffffff);

  @media (max-width: 700px) {
    padding: 4.5rem 0;
  }
`;

export const Container = styled.div`
  width: 100%;
  text-align: center;
`;

export const Heading = styled.div`
  width: min(calc(100% - 3rem), 720px);
  margin: 0 auto 3rem;

  @media (max-width: 700px) {
    width: min(calc(100% - 2.5rem), 720px);
    margin-bottom: 2.25rem;
  }
`;

export const Title = styled.h2`
  margin: 0;
  color: var(--foreground, #171717);
  font-size: clamp(2rem, 4vw, 3.2rem);
  font-weight: 700;
  line-height: 1.08;
  letter-spacing: -0.035em;
`;

export const Description = styled.p`
  max-width: 650px;
  margin: 1.25rem auto 0;
  color: var(--grey6, #5b6472);
  font-size: 1rem;
  line-height: 1.75;
`;

export const MarqueeWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  padding: 1.25rem 0;
  border-top: 1px solid var(--grey3, #e2e7ee);
  border-bottom: 1px solid var(--grey3, #e2e7ee);
  background: var(--yellow1, #f2f8ff);

  &::before,
  &::after {
    position: absolute;
    z-index: 2;
    top: 0;
    width: 120px;
    height: 100%;
    pointer-events: none;
    content: '';
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, var(--yellow1, #f2f8ff), transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, var(--orange1, #f2f8ff), transparent);
  }

  &:hover > div {
    animation-play-state: paused;
  }

  @media (max-width: 700px) {
    &::before,
    &::after {
      width: 55px;
    }
  }
`;

export const MarqueeTrack = styled.div`
  display: flex;
  width: max-content;
  align-items: center;
  animation: ${scrollBrands} 28s linear infinite;
  will-change: transform;

  @media (prefers-reduced-motion: reduce) {
    animation-play-state: paused;
  }
`;

export const BrandItem = styled.div`
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: 2.5rem;
  padding-left: 2.5rem;

  @media (max-width: 700px) {
    gap: 1.75rem;
    padding-left: 1.75rem;
  }
`;

export const BrandName = styled.span`
  color: var(--foreground, #171717);
  font-size: clamp(1rem, 2vw, 1.3rem);
  font-weight: 700;
  line-height: 1;
  letter-spacing: -0.02em;
  white-space: nowrap;
  transition:
    color 180ms ease,
    transform 180ms ease;

  ${BrandItem}:hover & {
    color: var(--orange4);
    transform: translateY(-2px);
  }
`;

export const Dot = styled.span`
  width: 5px;
  height: 5px;
  flex-shrink: 0;
  border-radius: 50%;
  background: var(--orange4);
`;

export const Note = styled.p`
  width: min(calc(100% - 3rem), 650px);
  margin: 2.5rem auto 0;
  color: var(--grey6, #5b6472);
  font-size: 0.95rem;
  line-height: 1.7;
  margin-bottom: var(--space-l);
  @media (max-width: 700px) {
    width: min(calc(100% - 2.5rem), 650px);
  }
`;
